import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from 'contentful';
import type { TypeClientSkeleton } from './TypeClient';
import type { TypeImageWrapperSkeleton } from './TypeImageWrapper';

export interface TypeBlockClientTestimonialFields {
    internalName?: EntryFieldTypes.Symbol;
    authorName: EntryFieldTypes.Symbol;
    authorTitle?: EntryFieldTypes.Symbol;
    client?: EntryFieldTypes.EntryLink<TypeClientSkeleton>;
    quote: EntryFieldTypes.Text;
    quoteShort?: EntryFieldTypes.Text;
    image?: EntryFieldTypes.EntryLink<TypeImageWrapperSkeleton>;
}

export type TypeBlockClientTestimonialSkeleton = EntrySkeletonType<
    TypeBlockClientTestimonialFields,
    'blockClientTestimonial'
>;
export type TypeBlockClientTestimonial<
    Modifiers extends ChainModifiers,
    Locales extends LocaleCode = LocaleCode,
> = Entry<TypeBlockClientTestimonialSkeleton, Modifiers, Locales>;

export function isTypeBlockClientTestimonial<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
    entry: Entry<EntrySkeletonType, Modifiers, Locales>
): entry is TypeBlockClientTestimonial<Modifiers, Locales> {
    return entry.sys.contentType.sys.id === 'blockClientTestimonial';
}
